export default {
    delete_billing_account_title: 'Delete Billing Account',
    delete_billing_account_descrption: 'Are you sure you want to delete this billing account? This action cannot be undone.',
    delete_billing_account_successfully_delete: 'The billing account was deleted successfully',
    delete_billing_account_error_delete: 'An error occurred while deleting the billing account',
    delete_billing_account_new_billing_account: 'New Billing Account',
    delete_billing_account_new_billing_account_message: '* You can select a new billing account to assign the device of the billing account you are deleting',
};